<template>
    <v-row align="start" justify="start">
      <v-card class="pa-2 col-sm-12">
      <v-skeleton-loader :loading="firstLoad && loading" type="table">
        <v-row no-gutters align="center">
          <v-col cols="12" md="6">
            <h3 class="color-services">Master Data</h3>
          </v-col>
          <v-col>
            <v-row
              no-gutters
              justify="end"
              align="center"
            >
              <!-- <v-col v-if="$store.state.isMobile">
                <v-text-field
                  outlined
                  v-model="search"
                  hide-details
                  placeholder="Search Masters"
                  prepend-inner-icon="mdi-magnify"
                  color="indigo accent-3"
                  class="search-field"
                ></v-text-field>
              </v-col>

              <v-text-field
                v-if="!$store.state.isMobile"
                outlined
                v-model="search"
                hide-details
                placeholder="Search Masters"
                prepend-inner-icon="mdi-magnify"
                color="indigo accent-3"
                class="pe-3 search-field"
              ></v-text-field> -->
            </v-row>
          </v-col>
        </v-row>
        <v-divider class="mt-2 mb-1"></v-divider>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer
          :calculate-widths="false"
          mobile-breakpoint="0"
          class="clickable-table"
        >
        <template v-slot:no-data>
            <EmptyState text="Master Data" />
        </template>
        <template v-slot:[`item.action`]="{ item }">
            <v-btn
              text
              color="indigo accent-3"
              style="text-transform: none;"
              small
              :to="{
                name: routerPath.adminPanel.children.masters.children.mastersDetails.name,
                params: { id: item.id },
              }"
            >
              <span>View Details</span>
            </v-btn>
          </template>
        </v-data-table>
      </v-skeleton-loader>
      </v-card>
    </v-row>
</template>
<script>

// import CityTable from "./CIty/List/CityList"
// import StateTable from "./State/List/StateList"
// import CountryTable from "./Country/List/CountryList"
// import GenderTable from "./Gender/List/GenderList"
// import GradeTable from "./Grade/List/GradeList"
// import ClientTypeTable from "./ClientType/List/ClientTypeList"
// import GroupTable from "./Group/List/GroupList"
// import RoleTable from "./Role/List/RoleList"
import { ROUTER_URL } from "../../../constants/urls";
import EmptyState from "../../../components/EmptyState/EmptyState";
import values from "../../../constants/values";

export default {
  name: "MastersList",
  components: {
    EmptyState
  },
  data() {
    return {
      routerPath: ROUTER_URL,
      items: values.masters_data_tables,
      search: "",
      itemsTotal: 0,
      loading: false,
      firstLoad: false,
      isMobile: false,
      pagination: { sortBy: ["name"], sortDesc: [false] },
      headers: [
        {
          text: "Sr. No.",
          value: "id",
          class: "black--text font-weight-bold ",
          width: "5%",
        },
        {
          text: "Master Data Name",
          value: "name",
          sortable: false,
          class: "black--text font-weight-bold",
          width: "20%",
        },
        {
          text: "Description",
          value: "desc",
          sortable: false,
          class: "black--text font-weight-bold",
          align: "center",
          width: "40%",
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
          class: "black--text font-weight-bold",
          align: "center",
          width: "10%",
        },
      ],
    };
  },
  methods: {

  },
  mounted() {
    
  }
};
</script>
